import React from "react";
import { useInjectReducer, useInjectSaga } from "redux-injectors";

import { AuthRepoSaga } from "../../../views/auth/saga";
import {
  sliceKey as AuthSliceKey,
  reducer as AuthReducer,
} from "../../../views/auth/slice";

import { CategoryRepoSaga } from "../../../views/admin/Category/redux/saga";
import {
  sliceKey as categorySliceKey,
  reducer as categoryReducer,
} from "../../../views/admin/Category/redux/slice";

import { SubCategoryRepoSaga } from "../../../views/admin/sub-category/redux/saga";
import {
  sliceKey as subCategorySliceKey,
  reducer as subCategoryReducer,
} from "../../../views/admin/sub-category/redux/slice";

import {
  sliceKey as productSliceKey,
  reducer as productReducer,
} from "../../../views/admin/product/redux/slice";
import { ProductRepoSaga } from "../../../views/admin/product/redux/saga";

import {
  sliceKey as fileSliceKey,
  reducer as fileReducer,
} from "../../Common/CustomUpload/redux/slice";
import { FileRepoSaga } from "../../Common/CustomUpload/redux/saga";

import {
  sliceKey as groupSliceKey,
  reducer as groupReducer,
} from "../../../views/admin/group/redux/slice";
import { GroupRepoSaga } from "../../../views/admin/group/redux/saga";

import {
  sliceKey as packageSliceKey,
  reducer as packageReducer,
} from "../../../views/admin/package/redux/slice";
import { packageRepoSaga } from "../../../views/admin/package/redux/saga";

import {
  sliceKey as categoryRetailerSliceKey,
  reducer as categoryRetailerReducer,
} from "../../../views/admin/retailer-category/redux/slice";
import { categoryRetailerRepoSaga } from "../../../views/admin/retailer-category/redux/saga";

import {
  sliceKey as productRetailerSliceKey,
  reducer as productRetailerReducer,
} from "../../../views/admin/retailer-product/redux/slice";
import { productRetailerRepoSaga } from "../../../views/admin/retailer-product/redux/saga";

import {
  sliceKey as UserSliceKey,
  reducer as UserReducer,
} from "../../../views/admin/user/redux/slice";
import { UserRepoSaga } from "../../../views/admin/user/redux/saga";

import {
  sliceKey as ShippingSliceKey,
  reducer as ShippingReducer,
} from "../../../views/admin/shipping/redux/slice";
import { ShippingRepoSaga } from "../../../views/admin/shipping/redux/saga";

import {
  sliceKey as retailerSliceKey,
  reducer as retailerReducer,
} from "../../../views/admin/retailer/redux/slice";
import { RetailerRepoSaga } from "../../../views/admin/retailer/redux/saga";

import {
  sliceKey as GroupProductSliceKey,
  reducer as GroupProductReducer,
} from "../../../views/admin/group-product/redux/slice";
import { GroupProductRepoSaga } from "../../../views/admin/group-product/redux/saga";

import {
  sliceKey as OrderSliceKey,
  reducer as OrderReducer,
} from "../../../views/admin/order/redux/slice";
import { OrderRepoSaga } from "../../../views/admin/order/redux/saga";

import {
  sliceKey as CampaignSliceKey,
  reducer as CampaignReducer,
} from "../../../views/admin/campaign/redux/slice";
import { CampaignRepoSaga } from "../../../views/admin/campaign/redux/saga";

import {
  sliceKey as NewsSliceKey,
  reducer as NewsReducer,
} from "../../../views/admin/campaign-news/redux/slice";
import { NewsRepoSaga } from "../../../views/admin/campaign-news/redux/saga";

import {
  sliceKey as StoreSliceKey,
  reducer as StoreReducer,
} from "../../../views/admin/store/redux/slice";
import { StoreRepoSaga } from "../../../views/admin/store/redux/saga";

import {
  sliceKey as ContactUsSliceKey,
  reducer as ContactUsReducer,
} from "../../../views/admin/contact-us/redux/slice";
import { ContactUsRepoSaga } from "../../../views/admin/contact-us/redux/saga";

import {
  sliceKey as DashboardSliceKey,
  reducer as DashboardReducer,
} from "../../../views/admin/dashboards/redux/slice";
import { DashboardRepoSaga } from "../../../views/admin/dashboards/redux/saga";

import {
  sliceKey as ImageUploadSliceKey,
  reducer as ImageUploadReducer,
} from "../../../views/admin/images-upload/redux/slice";
import { ImageUploadRepoSaga } from "../../../views/admin/images-upload/redux/saga";

interface Props {
  children: any;
}

const Index: React.FC<Props> = ({ children }) => {
  /************** */
  useInjectReducer({
    key: AuthSliceKey,
    reducer: AuthReducer,
  });
  useInjectSaga({ key: AuthSliceKey, saga: AuthRepoSaga });
  /************** */

  /************** Category */

  useInjectReducer({
    key: categorySliceKey,
    reducer: categoryReducer,
  });
  useInjectSaga({ key: categorySliceKey, saga: CategoryRepoSaga });
  /**************Category */
  /**************Sub category */
  useInjectReducer({
    key: subCategorySliceKey,
    reducer: subCategoryReducer,
  });
  useInjectSaga({ key: subCategorySliceKey, saga: SubCategoryRepoSaga });
  /**************Sub category */
  /**************product */
  useInjectReducer({
    key: productSliceKey,
    reducer: productReducer,
  });
  useInjectSaga({ key: productSliceKey, saga: ProductRepoSaga });
  /**************product */
  /**************file */
  useInjectReducer({
    key: fileSliceKey,
    reducer: fileReducer,
  });
  useInjectSaga({ key: fileSliceKey, saga: FileRepoSaga });
  /**************file */
  /**************group */
  useInjectReducer({
    key: groupSliceKey,
    reducer: groupReducer,
  });
  useInjectSaga({ key: groupSliceKey, saga: GroupRepoSaga });
  /**************group */
  /**************package */
  useInjectReducer({
    key: packageSliceKey,
    reducer: packageReducer,
  });
  useInjectSaga({ key: packageSliceKey, saga: packageRepoSaga });
  /**************package */

  /**************Retailer  */
  /**************category retailer */
  useInjectReducer({
    key: categoryRetailerSliceKey,
    reducer: categoryRetailerReducer,
  });
  useInjectSaga({
    key: categoryRetailerSliceKey,
    saga: categoryRetailerRepoSaga,
  });
  /**************category retailer */

  /**************product retailer */
  useInjectReducer({
    key: productRetailerSliceKey,
    reducer: productRetailerReducer,
  });
  useInjectSaga({
    key: productRetailerSliceKey,
    saga: productRetailerRepoSaga,
  });
  /**************product retailer */
  /**************User */
  useInjectReducer({
    key: UserSliceKey,
    reducer: UserReducer,
  });
  useInjectSaga({
    key: UserSliceKey,
    saga: UserRepoSaga,
  });
  /**************User */
  /**************shipping */
  useInjectReducer({
    key: ShippingSliceKey,
    reducer: ShippingReducer,
  });
  useInjectSaga({
    key: ShippingSliceKey,
    saga: ShippingRepoSaga,
  });
  /**************shipping */
  /**************Retailer */
  useInjectReducer({
    key: retailerSliceKey,
    reducer: retailerReducer,
  });
  useInjectSaga({
    key: retailerSliceKey,
    saga: RetailerRepoSaga,
  });
  /**************Retailer */
  /**************group product */
  useInjectReducer({
    key: GroupProductSliceKey,
    reducer: GroupProductReducer,
  });
  useInjectSaga({
    key: GroupProductSliceKey,
    saga: GroupProductRepoSaga,
  });
  /**************group product */
  /**************order product */
  useInjectReducer({
    key: OrderSliceKey,
    reducer: OrderReducer,
  });
  useInjectSaga({
    key: OrderSliceKey,
    saga: OrderRepoSaga,
  });
  /**************order product */
  /**************Campaign */
  useInjectReducer({
    key: CampaignSliceKey,
    reducer: CampaignReducer,
  });
  useInjectSaga({
    key: CampaignSliceKey,
    saga: CampaignRepoSaga,
  });
  /**************Campaign */
  /**************News */
  useInjectReducer({
    key:NewsSliceKey,
    reducer: NewsReducer,
  });
  useInjectSaga({
    key:NewsSliceKey,
    saga: NewsRepoSaga,
  });
  /**************News */
  /**************store */
  useInjectReducer({
    key:StoreSliceKey,
    reducer: StoreReducer,
  });
  useInjectSaga({
    key:StoreSliceKey,
    saga: StoreRepoSaga,
  });
  /**************store */
  /**************contact us */
  useInjectReducer({
    key: ContactUsSliceKey,
    reducer:  ContactUsReducer,
  });
  useInjectSaga({
    key:ContactUsSliceKey,
    saga: ContactUsRepoSaga,
  });
  /**************contact us */
  // Dashboard State
  useInjectReducer({ key: DashboardSliceKey, reducer: DashboardReducer });
  useInjectSaga({ key: DashboardSliceKey, saga: DashboardRepoSaga });
  // Image Upload
  useInjectReducer({ key: ImageUploadSliceKey, reducer: ImageUploadReducer });
  useInjectSaga({ key: ImageUploadSliceKey, saga: ImageUploadRepoSaga });
  return children;
};

export default Index;
